/* Cloudwear: interakcje strony produktu —
   1) modal wideo stories, 2) drawer tabeli rozmiarów, 3) sticky "Dodaj do koszyka" na mobile. */
(function () {
  /* i18n (EN etap 1): teksty z window.cwStrings (theme.liquid → locales),
     fallback PL — patrz analogiczny blok w cloudwear.js */
  var cwStr = window.cwStrings || {};
  var cwReviewsCount = function (n) {
    var few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14);
    var tpl = n === 1 ? (cwStr.reviewsOne || '[n] opinia')
      : few ? (cwStr.reviewsFew || '[n] opinie') : (cwStr.reviewsMany || '[n] opinii');
    return tpl.replace('[n]', n);
  };

  function openModal(modal) {
    modal.hidden = false;
    document.documentElement.classList.add('cw-modal-open');
    var video = modal.querySelector('video');
    if (video) video.play().catch(function () {});
  }
  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('cw-modal-open');
    modal.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cw-stories-open]')) {
      var m = document.querySelector('[data-cw-stories-modal]');
      if (m) openModal(m);
      return;
    }
    if (event.target.closest('[data-cw-stories-close]')) {
      var m2 = document.querySelector('[data-cw-stories-modal]');
      if (m2) closeModal(m2);
      return;
    }
    /* strzałki karuzeli stories: przewiń o slajd, pauzuj resztę, graj bieżący */
    var navBtn = event.target.closest('[data-cw-stories-prev], [data-cw-stories-next]');
    if (navBtn) {
      var track = document.querySelector('[data-cw-stories-track]');
      if (track) {
        var dir = navBtn.hasAttribute('data-cw-stories-next') ? 1 : -1;
        var w = track.clientWidth;
        var idx = Math.round(track.scrollLeft / w) + dir;
        if (idx < 0) idx = 0;
        if (idx > track.children.length - 1) idx = track.children.length - 1;
        track.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
        track.scrollTo({ left: idx * w, behavior: 'smooth' });
        var vid = track.children[idx] && track.children[idx].querySelector('video');
        if (vid) {
          window.setTimeout(function () {
            vid.play().catch(function () {});
          }, 350);
        }
      }
      return;
    }
    if (event.target.closest('[data-cw-sizetable-open]')) {
      var s = document.querySelector('[data-cw-sizetable-modal]');
      if (s) openModal(s);
      return;
    }
    if (event.target.closest('[data-cw-sizetable-close]')) {
      var s2 = document.querySelector('[data-cw-sizetable-modal]');
      if (s2) closeModal(s2);
      return;
    }
    if (event.target.closest('[data-cw-sticky-btn]')) {
      var submit = document.querySelector('.product-form__submit');
      if (submit) submit.click();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    ['[data-cw-stories-modal]', '[data-cw-sizetable-modal]'].forEach(function (sel) {
      var m = document.querySelector(sel);
      if (m && !m.hidden) closeModal(m);
    });
  });

  /* ── LIGHTBOX zdjęć PDP (28.08 v2, wzór GSQ — drugie zrzuty) ──
     klik w zdjęcie galerii otwiera biały fullscreen: X w kółku, pigułka
     „‹ 1/7 ›" na dole. Zoom: desktop klik (mousemove panoramuje, drugi klik
     oddala), mobile pinch dwoma palcami + przesuwanie jednym; swipe zmienia
     zdjęcie tylko bez zoomu */
  var lb = document.getElementById('CwLightbox');
  if (lb) {
    var lbStage = lb.querySelector('[data-cw-lb-stage]');
    var lbImg = lb.querySelector('[data-cw-lb-img]');
    var lbCount = lb.querySelector('[data-cw-lb-count]');
    var lbFulls = Array.prototype.slice.call(lb.querySelectorAll('[data-cw-lb-thumb]')).map(function (t) {
      return t.getAttribute('data-cw-lb-full');
    });
    var lbIndex = 0;
    var lbScale = 1;
    var lbTx = 0;
    var lbTy = 0;

    var lbApply = function () {
      lbImg.style.transform = lbScale > 1 ? 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')' : '';
      lb.classList.toggle('is-zoomed', lbScale > 1);
    };
    var lbResetZoom = function () {
      lbScale = 1;
      lbTx = 0;
      lbTy = 0;
      lbImg.style.transition = '';
      lbApply();
    };
    var lbClampPan = function () {
      var maxX = Math.max(0, (lbImg.offsetWidth * lbScale - lbStage.clientWidth) / 2);
      var maxY = Math.max(0, (lbImg.offsetHeight * lbScale - lbStage.clientHeight) / 2);
      lbTx = Math.min(maxX, Math.max(-maxX, lbTx));
      lbTy = Math.min(maxY, Math.max(-maxY, lbTy));
    };
    /* desktop: pozycja kursora w kadrze mapuje pełen zakres panoramy */
    var lbPanFromCursor = function (clientX, clientY) {
      var r = lbStage.getBoundingClientRect();
      var maxX = Math.max(0, (lbImg.offsetWidth * lbScale - r.width) / 2);
      var maxY = Math.max(0, (lbImg.offsetHeight * lbScale - r.height) / 2);
      lbTx = -((clientX - r.left) / r.width - 0.5) * 2 * maxX;
      lbTy = -((clientY - r.top) / r.height - 0.5) * 2 * maxY;
      lbClampPan();
      lbApply();
    };

    var lbShow = function (i) {
      var n = lbFulls.length;
      lbIndex = ((i % n) + n) % n;
      lbResetZoom();
      var full = lbFulls[lbIndex];
      lbImg.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () {
        lbImg.src = full;
        lbImg.style.opacity = '1';
      };
      pre.src = full;
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + n;
      /* preload sąsiadów */
      [lbIndex + 1, lbIndex - 1].forEach(function (j) {
        var k = ((j % n) + n) % n;
        var im = new Image();
        im.src = lbFulls[k];
      });
    };
    var lbOpen = function (i) {
      document.documentElement.classList.add('cw-modal-open');
      lb.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { lb.classList.add('is-open'); });
      });
      lbShow(i);
    };
    var lbClose = function () {
      document.documentElement.classList.remove('cw-modal-open');
      lb.classList.remove('is-open');
      window.setTimeout(function () {
        lb.hidden = true;
        lbResetZoom();
      }, 250);
    };

    /* klik w zdjęcie galerii — zamiast Dawnowego modala */
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest && event.target.closest('.product__media-toggle');
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        var item = toggle.closest('.product__media-item');
        var items = Array.prototype.slice.call(document.querySelectorAll('.product__media-list .product__media-item'));
        lbOpen(Math.max(0, items.indexOf(item)));
        return;
      }
      if (lb.hidden) return;
      if (event.target.closest && event.target.closest('[data-cw-lb-close]')) {
        lbClose();
        return;
      }
      var nav = event.target.closest && event.target.closest('[data-cw-lb-nav]');
      if (nav) {
        lbShow(lbIndex + parseInt(nav.getAttribute('data-cw-lb-nav'), 10));
        return;
      }
      /* desktop: klik w zdjęcie = zoom w punkcie kliknięcia, drugi klik oddala */
      if (event.target === lbImg && window.matchMedia('(hover: hover)').matches) {
        if (lbScale > 1) {
          lbResetZoom();
        } else {
          lbScale = 2.5;
          lbPanFromCursor(event.clientX, event.clientY);
        }
        return;
      }
      /* klik w białe tło poza zdjęciem zamyka */
      if (event.target === lbStage) lbClose();
    }, true);

    lbStage.addEventListener('mousemove', function (event) {
      if (lbScale <= 1 || !window.matchMedia('(hover: hover)').matches) return;
      lbPanFromCursor(event.clientX, event.clientY);
    });

    document.addEventListener('keydown', function (event) {
      if (lb.hidden) return;
      if (event.key === 'Escape') lbClose();
      else if (event.key === 'ArrowRight') lbShow(lbIndex + 1);
      else if (event.key === 'ArrowLeft') lbShow(lbIndex - 1);
    });

    /* mobile: pinch dwoma palcami + przesuwanie jednym (pointer events,
       touch-action:none na stage wyłącza natywny zoom/scroll strony) */
    var lbPtrs = {};
    var lbPinch = null;
    var lbDrag = null;
    lbStage.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      lbPtrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(lbPtrs);
      if (ids.length === 2) {
        var a = lbPtrs[ids[0]];
        var b = lbPtrs[ids[1]];
        lbPinch = {
          d0: Math.hypot(a.x - b.x, a.y - b.y),
          s0: lbScale,
          mx0: (a.x + b.x) / 2,
          my0: (a.y + b.y) / 2,
          tx0: lbTx,
          ty0: lbTy
        };
        lbDrag = null;
        lbImg.style.transition = 'opacity 0.2s ease';
      } else if (ids.length === 1 && lbScale > 1) {
        lbDrag = { x: e.clientX, y: e.clientY, tx0: lbTx, ty0: lbTy };
        lbImg.style.transition = 'opacity 0.2s ease';
      }
    });
    lbStage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'touch' || !lbPtrs[e.pointerId]) return;
      lbPtrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(lbPtrs);
      var sr = lbStage.getBoundingClientRect();
      var cx = sr.left + sr.width / 2;
      var cy = sr.top + sr.height / 2;
      if (lbPinch && ids.length >= 2) {
        var a = lbPtrs[ids[0]];
        var b = lbPtrs[ids[1]];
        var mx = (a.x + b.x) / 2;
        var my = (a.y + b.y) / 2;
        lbScale = Math.min(4, Math.max(1, lbPinch.s0 * (Math.hypot(a.x - b.x, a.y - b.y) / lbPinch.d0)));
        /* punkt zdjęcia pod środkiem palców zostaje pod palcami */
        var k = lbScale / lbPinch.s0;
        lbTx = mx - cx - (lbPinch.mx0 - cx - lbPinch.tx0) * k;
        lbTy = my - cy - (lbPinch.my0 - cy - lbPinch.ty0) * k;
        lbClampPan();
        lbApply();
      } else if (lbDrag && ids.length === 1 && lbScale > 1) {
        lbTx = lbDrag.tx0 + (e.clientX - lbDrag.x);
        lbTy = lbDrag.ty0 + (e.clientY - lbDrag.y);
        lbClampPan();
        lbApply();
      }
    });
    var lbPtrUp = function (e) {
      delete lbPtrs[e.pointerId];
      if (Object.keys(lbPtrs).length < 2) lbPinch = null;
      if (Object.keys(lbPtrs).length === 0) {
        lbDrag = null;
        lbImg.style.transition = '';
        if (lbScale < 1.05) lbResetZoom();
      }
    };
    lbStage.addEventListener('pointerup', lbPtrUp);
    lbStage.addEventListener('pointercancel', lbPtrUp);

    /* swipe zmienia zdjęcie — tylko bez zoomu i jednym palcem */
    var lbTouchX = null;
    lb.addEventListener('touchstart', function (event) {
      lbTouchX = (event.touches.length === 1 && lbScale === 1) ? event.touches[0].clientX : null;
    }, { passive: true });
    lb.addEventListener('touchend', function (event) {
      if (lbTouchX === null || lbScale > 1) return;
      var dx = event.changedTouches[0].clientX - lbTouchX;
      lbTouchX = null;
      if (Math.abs(dx) > 48) lbShow(lbIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ── Serce wishlisty vs STOQ „Powiadom o dostępności" (05.09) ──
     Na wyprzedanym wariancie STOQ chowa submit i wstrzykuje własny przycisk
     do FORMULARZA (poza .product-form__buttons) — serce zostawało sierotą
     nad przyciskiem. Gdy submit ukryty a kontener STOQ istnieje, serce
     przenosi się do niego (flex obok przycisku); wraca przy dostępnym
     wariancie. STOQ przerysowuje kontener — obserwator dosynchronizowuje
     (appendChild odzyskuje węzeł nawet po wipe przez innerHTML). */
  (function () {
    var heart = document.querySelector('.cw-wl-pdp');
    var buttonsBox = document.querySelector('.product-form__buttons');
    if (!heart || !buttonsBox) return;
    var sync = function () {
      var submit = document.querySelector('.product-form__submit');
      var stoq = document.querySelector('.restock-rocket-button-container');
      var submitHidden = !submit || submit.offsetParent === null;
      if (submitHidden && stoq) {
        if (heart.parentElement !== stoq) stoq.appendChild(heart);
        stoq.classList.add('cw-has-heart');
      } else if (heart.parentElement !== buttonsBox) {
        buttonsBox.appendChild(heart);
      }
    };
    sync();
    if (window.MutationObserver) {
      var syncTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(sync, 120);
      }).observe(document.querySelector('.product-form') || document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }
  })();

  /* ── Opinie produktu: TrustMate hydra → własna LISTA (04.09 v3) ──
     Hydra po przejęciu renderuje się poza ekranem; zbieramy z niej opinie
     (doklikując ukryte „pokaż więcej" — dozbiera wszystkie strony) do
     tablicy i rysujemy pionową listę: 3 (mobile) / 6 (desktop) na start
     + przycisk „Pokaż więcej opinii". Sortowanie: najnowsze / najwyżej /
     najniżej. Filtr: klik w wiersz rozkładu gwiazdek (toggle).
     Nad listą trójpanelowe podsumowanie (średnia | rozkład | sondaże)
     z agregatów hydry. Brak opinii → sekcja ukryta. */
  (function () {
    var root = document.querySelector('[data-cw-opr]');
    if (!root) return;
    var track = root.querySelector('[data-cw-op-track]');
    var meta = root.querySelector('[data-cw-op-meta]');
    var bar = root.querySelector('[data-cw-opr-bar]');
    var sortSel = root.querySelector('[data-cw-opr-sort]');
    var moreBtn = root.querySelector('[data-cw-opr-more]');
    if (!track) return;
    var esc = function (s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    };
    var items = [];
    var state = {
      sort: 'newest',
      star: null,
      base: window.matchMedia('(max-width: 749px)').matches ? 3 : 6,
      visible: 0,
    };
    state.visible = state.base;

    var parseWhen = function (s) {
      var m = (s || '').match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
      if (m) return new Date(+m[3], +m[2] - 1, +m[1]).getTime();
      /* hydra na /en może podać inny format daty — Date.parse jako siatka,
         a przy porażce 0 (sortowanie stabilne, bez wywrotki) */
      var t = Date.parse(s || '');
      return isNaN(t) ? 0 : t;
    };

    var cardHtml = function (it) {
      return '<article class="cw-op__card">'
        + '<span class="cw-op__stars" aria-label="' + it.grade + '/5"><span class="cw-op__stars-fill" style="width:' + it.grade * 20 + '%">★★★★★</span><span class="cw-op__stars-base" aria-hidden="true">★★★★★</span></span>'
        + '<div class="cw-op__who">'
        + '<span class="cw-op__name">' + esc(it.name) + '</span>'
        + (it.verified ? '<span class="cw-op__badge" style="background-image:' + it.badgeBg.replace(/"/g, '&quot;') + '" title="' + (cwStr.verified || 'zweryfikowano') + '"></span>' : '')
        + (it.when ? '<span class="cw-op__when">' + esc(it.when) + '</span>' : '')
        + '</div>'
        + '<p class="cw-op__text">' + esc(it.text) + '</p>'
        + '</article>';
    };

    var renderList = function () {
      var list = items.slice();
      if (state.star) {
        list = list.filter(function (it) { return it.grade === state.star; });
      }
      if (state.sort === 'best') list.sort(function (a, b) { return b.grade - a.grade || b.whenTs - a.whenTs; });
      else if (state.sort === 'worst') list.sort(function (a, b) { return a.grade - b.grade || b.whenTs - a.whenTs; });
      else list.sort(function (a, b) { return b.whenTs - a.whenTs || a.idx - b.idx; });
      var shown = list.slice(0, state.visible);
      track.innerHTML = shown.map(cardHtml).join('');
      if (moreBtn) moreBtn.hidden = list.length <= state.visible;
      if (bar) bar.hidden = items.length < 2;
      /* stan aktywnego filtra na wierszach rozkładu */
      root.querySelectorAll('.cw-opr-dist__row').forEach(function (row) {
        row.classList.toggle('is-active', state.star !== null && parseInt(row.getAttribute('data-cw-grade'), 10) === state.star);
      });
    };

    /* zbiórka: karty hydry → tablica items + meta/panele podsumowania */
    var harvest = function (hydra) {
      var cards = hydra.querySelectorAll('.hydra-main-reviews__list-review-wrapper');
      if (!cards.length) return 0;
      var badge = hydra.querySelector('.tm-review-source .tm-icon');
      var badgeBg = badge ? getComputedStyle(badge).backgroundImage : 'none';
      items = [];
      cards.forEach(function (c, idx) {
        var grade = parseInt(c.getAttribute('data-tm-grade-review'), 10) || 0;
        if (!grade || grade < 2) return; /* bez 1★ (decyzja Michała, jak na home) */
        var name = ((c.querySelector('.hydra-main-reviews__name') || {}).textContent || '').trim();
        /* dopisek „dotyczy podobnego produktu" siedzi WEWNĄTRZ tekstu — wycinamy */
        var text = '';
        var textEl = c.querySelector('.hydra-main-reviews__text');
        if (textEl) {
          var tClone = textEl.cloneNode(true);
          tClone.querySelectorAll('.tm-product-origin').forEach(function (o) { o.remove(); });
          text = (tClone.textContent || '').trim();
        }
        if (!text) return;
        var when = ((c.querySelector('.hydra-main-reviews__created-at') || {}).textContent || '').trim();
        var verTxt = ((c.querySelector('.hydra-main-reviews__verified') || {}).textContent || '').trim().toLowerCase();
        items.push({
          idx: idx,
          grade: grade,
          name: name,
          text: text,
          when: when,
          whenTs: parseWhen(when),
          /* hydra może renderować etykiety PL albo EN (nieudokumentowane) */
          verified: verTxt.indexOf('zweryfikowan') > -1 || verTxt.indexOf('verified') > -1,
          badgeBg: badgeBg,
        });
      });
      if (!items.length) return 0;
      /* meta: średnia + licznik (odmiana) + wypełnienie gwiazdek */
      var gM = ((hydra.querySelector('.hydra-grade__value') || {}).textContent || '').match(/\d+[.,]\d+|\d+/);
      var cM = ((hydra.querySelector('.hydra-grade__reviews-count') || hydra.querySelector('.hydra-grade__reviews') || {}).textContent || '').match(/\d+/);
      var gradeEl = root.querySelector('[data-cw-op-grade]');
      var countEl = root.querySelector('[data-cw-op-count]');
      if (gradeEl && gM) gradeEl.textContent = gM[0];
      if (cM && countEl) {
        countEl.textContent = cwReviewsCount(parseInt(cM[0], 10));
      }
      var sf = root.querySelector('[data-cw-op-starsfill]');
      if (sf && gM) sf.style.width = parseFloat(gM[0].replace(',', '.')) * 20 + '%';
      /* panel 2: rozkład gwiazdek (wiersze klikalne = filtr) */
      var distEl = root.querySelector('[data-cw-op-dist]');
      if (distEl) {
        var distHtml = '';
        hydra.querySelectorAll('.hydra-grade-distribution__grade-chart').forEach(function (row) {
          var dg = ((row.querySelector('.hydra-grade-distribution__grade') || {}).textContent || '').trim();
          var dp = ((row.querySelector('.hydra-grade-distribution__bar-value-percent') || {}).textContent || '').trim();
          var dw = parseInt(dp, 10) || 0;
          if (!dg) return;
          distHtml += '<div class="cw-opr-dist__row' + (dw > 0 ? ' is-filter' : '') + '" data-cw-grade="' + esc(dg) + '"'
            + (dw > 0 ? ' role="button" tabindex="0" aria-label="' + (cwStr.reviewsFilterAria || 'Pokaż opinie z oceną [grade]').replace('[grade]', esc(dg)) + '"' : '')
            + '><span class="cw-opr-dist__grade">' + esc(dg) + ' <i>★</i></span><span class="cw-opr-dist__bar"><span style="width:' + dw + '%"></span></span><span class="cw-opr-dist__pct">' + esc(dp) + '</span></div>';
        });
        if (distHtml) {
          distEl.innerHTML = distHtml;
          distEl.hidden = false;
        }
      }
      /* panel 3: średnie sondaży (traits) — pozycje liczy TrustMate */
      var trEl = root.querySelector('[data-cw-op-traits]');
      if (trEl) {
        var trHtml = '';
        hydra.querySelectorAll('.hydra-trait__wrapper').forEach(function (w) {
          var tName = ((w.querySelector('.hydra-trait__header') || {}).textContent || '').trim();
          var act = w.querySelector('.hydra-trait__active');
          var actAns = w.querySelector('.hydra-trait__answear--active');
          var tVal = ((act && act.textContent) || (actAns && actAns.textContent) || '').trim();
          var dart = w.querySelector('.hydra-trait__dart');
          var posSrc = (dart && dart.style.left) || (act && act.style.left) || '50%';
          var posM = posSrc.match(/(\d+(?:\.\d+)?)%/);
          var tLeft = (posM ? posM[1] : '50') + '%';
          var tFirst = ((w.querySelector('.hydra-trait__answear--first') || {}).textContent || '').trim();
          var tLast = ((w.querySelector('.hydra-trait__answear--last') || {}).textContent || '').trim();
          if (!tName || !tVal) return;
          var labels;
          if (tVal === tFirst) {
            labels = '<span class="is-on">' + esc(tFirst) + '</span><span>' + esc(tLast) + '</span>';
          } else if (tVal === tLast) {
            labels = '<span>' + esc(tFirst) + '</span><span class="is-on">' + esc(tLast) + '</span>';
          } else {
            labels = '<span>' + esc(tFirst) + '</span><span class="cw-opr-tr__val" style="left:' + esc(tLeft) + '">' + esc(tVal) + '</span><span>' + esc(tLast) + '</span>';
          }
          trHtml += '<div class="cw-opr-tr"><span class="cw-opr-tr__name">' + esc(tName) + '</span>'
            + '<span class="cw-opr-tr__track"><i class="cw-opr-tr__dot" style="left:' + esc(tLeft) + '"></i></span>'
            + '<span class="cw-opr-tr__labels">' + labels + '</span></div>';
        });
        if (trHtml) {
          trEl.innerHTML = trHtml;
          trEl.hidden = false;
        }
      }
      if (window.cwOpLogo) window.cwOpLogo(root, hydra.querySelector('.hydra-grade__logo img'));
      renderList();
      return items.length;
    };

    /* dozbieranie: klikamy „pokaż więcej" w ukrytym widgecie, aż lista
       przestanie rosnąć (max 8 stron) — sort/filtr dostają komplet */
    var expand = function (hydra, prevCount, hops) {
      var more = hydra.querySelector('.hydra-main-reviews__show-more button, button.hydra-main-reviews__show-more, .hydra-main-reviews__show-more');
      if (!more || hops > 8) return;
      more.click();
      window.setTimeout(function () {
        var now = hydra.querySelectorAll('.hydra-main-reviews__list-review-wrapper').length;
        if (now > prevCount) {
          harvest(hydra);
          expand(hydra, now, hops + 1);
        }
      }, 900);
    };

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var hydra = document.querySelector('.tm-hydra');
      if (!hydra || !harvest(hydra)) {
        /* porażka = sygnał dla oceny przy cenie (cloudwear.js), żeby się schowała:
           szybciej, gdy appka w ogóle nie wstrzyknęła widgetu (produkt bez opinii) */
        if ((tries > 32 && !hydra) || tries > 60) {
          window.clearInterval(timer);
          document.documentElement.classList.add('cw-opr-none');
          try { localStorage.setItem('cw:oprv2:' + ((window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || ''), '0'); } catch (e) {}
        }
        return;
      }
      window.clearInterval(timer);
      document.documentElement.classList.add('cw-opr-ready');
      try { localStorage.setItem('cw:oprv2:' + ((window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || ''), '1'); } catch (e) {}
      root.hidden = false;
      track.hidden = false;
      if (meta) meta.hidden = false;
      expand(hydra, hydra.querySelectorAll('.hydra-main-reviews__list-review-wrapper').length, 1);
    }, 250);

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        state.visible = state.base;
        renderList();
      });
    }
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.visible += state.base;
        renderList();
      });
    }
    /* filtr: klik (lub Enter) w wiersz rozkładu z opiniami */
    root.addEventListener('click', function (event) {
      var row = event.target.closest && event.target.closest('.cw-opr-dist__row.is-filter');
      if (!row) return;
      var g = parseInt(row.getAttribute('data-cw-grade'), 10);
      state.star = state.star === g ? null : g;
      state.visible = state.base;
      renderList();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var row = event.target.closest && event.target.closest('.cw-opr-dist__row.is-filter');
      if (!row) return;
      event.preventDefault();
      row.click();
    });
  })();

  /* ── Wysyłka: dynamiczny cutoff (01.09) ──
     Czas EUROPE/WARSAW (niezależnie od strefy klientki). Dni robocze <13:00 →
     licznik „wysyłka jeszcze dziś"; po cutoffie → jutro / w poniedziałek.
     Czw 16:30 → pt 11:00: dodatkowa linijka o Paczce w Weekend (sobota).
     Teksty z cwStrings/locale (EN etap 1), fallback PL inline. */
  (function () {
    var box = document.querySelector('[data-cw-shipbox]');
    if (!box) return;
    var mainEl = box.querySelector('[data-cw-ship-main]');
    var wkEl = box.querySelector('[data-cw-ship-weekend]');
    var CUTOFF = 13 * 60;
    var DAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    var warsawNow = function () {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Warsaw',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var get = function (t) {
        var p = parts.find(function (x) { return x.type === t; });
        return p ? p.value : '';
      };
      return { dow: DAYS[get('weekday')], min: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
    };
    var iconTruck = box.querySelector('[data-cw-ship-icon="truck"]');
    var iconClock = box.querySelector('[data-cw-ship-icon="clock"]');
    var render = function () {
      var t = warsawNow();
      if (isNaN(t.min) || t.dow === undefined) return; // fallback: zostaje statyczny tekst
      var workday = t.dow >= 1 && t.dow <= 5;
      var counting = false;
      if (workday && t.min < CUTOFF) {
        var left = CUTOFF - t.min;
        /* licznik dopiero gdy zostało ≤5h (od 8:00) — w nocy „12 godz. 58 min"
           wyglądało absurdalnie (uwaga Michała 01.09); wcześniej statycznie */
        if (left > 300) {
          mainEl.innerHTML = cwStr.shipToday || 'Zamów do <strong>13:00</strong> - wysyłka <strong>jeszcze dziś</strong>';
        } else {
          counting = true;
          var h = Math.floor(left / 60);
          var m = left % 60;
          var hUnit = cwStr.hoursShort || 'godz.';
          var mUnit = cwStr.minShort || 'min';
          var czas = m + ' ' + mUnit;
          if (h > 0) czas = m > 0 ? h + ' ' + hUnit + ' ' + m + ' ' + mUnit : h + ' ' + hUnit;
          mainEl.innerHTML = (cwStr.shipWithin || 'Zamów w ciągu <strong>[time]</strong> - wysyłka <strong>jeszcze dziś</strong>').replace('[time]', czas);
        }
      } else if (t.dow >= 5 || t.dow === 0) {
        mainEl.innerHTML = cwStr.shipMonday || 'Zamów teraz - wysyłka <strong>w poniedziałek</strong>';
      } else {
        mainEl.innerHTML = cwStr.shipTomorrow || 'Zamów teraz - wysyłka <strong>jutro</strong>';
      }
      /* licznik = zegar zamiast ciężarówki (uwaga Michała 01.09) */
      if (iconTruck) iconTruck.hidden = counting;
      if (iconClock) iconClock.hidden = !counting;
      /* Paczka w Weekend: czw 16:30 → pt 11:00 */
      var wkOn = (t.dow === 4 && t.min >= 990) || (t.dow === 5 && t.min < 660);
      wkEl.hidden = !wkOn;
    };
    render();
    window.setInterval(render, 30000);
  })();

  /* Sticky ATC: pokazuj, gdy główny przycisk "Dodaj do koszyka" został przescrollowany.
     Elementy odpytujemy przy każdym ticku (hot reload / section rendering podmienia DOM). */
  var cwStickyTick = false;
  function cwUpdateSticky() {
    cwStickyTick = false;
    var sticky = document.querySelector('[data-cw-sticky]');
    var submit = document.querySelector('.product-form__submit');
    if (!sticky || !submit) return;
    /* 31.08 (LORIS-bug): przy wyprzedanym wariancie submit jest disabled,
       a gdy STOQ wstawia „Powiadom mnie" — nasz CSS CHOWA submit
       (offsetParent === null → rect 0 → sticky pływał nad notify-me) */
    if (submit.disabled || submit.offsetParent === null) {
      sticky.hidden = true;
      return;
    }
    sticky.hidden = submit.getBoundingClientRect().bottom > 0;
  }
  function cwRequestSticky() {
    if (cwStickyTick) return;
    cwStickyTick = true;
    window.requestAnimationFrame(cwUpdateSticky);
  }
  window.addEventListener('scroll', cwRequestSticky, { passive: true });
  window.addEventListener('resize', cwRequestSticky);
  /* Fallback dla środowisk, które nie emitują zdarzeń scroll (podglądy/webview) */
  window.setInterval(cwRequestSticky, 400);
  cwRequestSticky();

  /* "Ostatnio wyświetlone" — zapis obejrzanego produktu do localStorage
     (odczyt i render w wyszukiwarce: cloudwear.js) */
  try {
    var titleEl = document.querySelector('.product__title h1, .product__title .h1');
    var imgMeta = document.querySelector('meta[property="og:image"]');
    var priceEl = document.querySelector('.product__info-container .price__container .price-item--last, .product__info-container .price-item--regular');
    if (titleEl) {
      var entry = {
        u: window.location.pathname,
        t: titleEl.textContent.trim(),
        i: imgMeta ? imgMeta.content : '',
        p: priceEl ? priceEl.textContent.trim() : ''
      };
      var recent = [];
      try { recent = JSON.parse(localStorage.getItem('cw:recent') || '[]'); } catch (e) { recent = []; }
      recent = recent.filter(function (r) { return r.u !== entry.u; });
      recent.unshift(entry);
      localStorage.setItem('cw:recent', JSON.stringify(recent.slice(0, 6)));
    }
  } catch (e) { /* localStorage niedostępny — pomijamy */ }
})();
